<div class="flex flex-col p-4 gap-4">
<h1 class="text-2xl leading-snug">Welches Fest möchten Sie besuchen?</h1>
<app-loading [isLoading]="bookableEvents().length === 0">
  <div class="flex flex-col gap-4" role="list" aria-label="Verfügbare Veranstaltungen">
    @for (event of bookableEvents(); track event.slug) {
      <button
         type="button"
         (click)="selectEvent(event)"
         class="bg-white rounded-xl flex flex-col hover:shadow-lg transition-shadow focus:outline-none focus:ring-2 focus:ring-benzRed-700 text-left w-full"
         role="listitem"
         [attr.aria-label]="'Buchen Sie ' + event.title">
        <img class="rounded-t-xl object-cover" alt="Banner für {{event.title}}" [src]="getTitleImagePath(event.slug)" (error)="onImageError($event)" />
        <div class="m-2">
          <h2 class="text-xl">{{ event.title }}</h2>
          <p class="text-sm text-benzGrey-600 mt-1">Vom {{ event.valid_from_date | date:'dd. MMMM' }} bis {{ event.valid_to_date | date:'dd. MMMM yyyy' }}</p>
        </div>
      </button>
    }
  </div>
</app-loading>
</div>
